<template>
    <footer class="login-footer">
        <div class="d-block justify-content-start">
            <div>
                <p>{{ cms.footerTxt }}</p>
            </div>
            <div>
                <h4>{{ cms.footerCtc }}</h4>
                <ul>
                    <li><a :href="'mailto:' + cms.footerMail" class="plain-link">{{ cms.footerMail }}</a></li>
                    <li><a :href="'//' + cms.footerQuestion" 
                            class="plain-link"
                            target="_blank">{{ cms.footerQuestion }}</a></li>
                </ul>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        data() {
            return {
                /* eslint-disable */
                cms: {
                    footerHead: FOOTER_HEAD,
                    footerTxt: FOOTER_TXT,
                    footerCtc: FOOTER_CTC,
                    footerMail: FOOTER_MAIL,
                    footerQuestion: FOOTER_QUESTION
                }
                /* eslint-enable */
            }
        }
    }
</script>